import * as React from "react";
import { CustomButton, ButtonType, Table } from "soprasteria-ui-library";
import { useHistory, useRouteMatch } from "react-router";
import { EMERGENCY_TREATMENT } from "../../../../utils/RouteConstants";
import { useAuth } from "../../../../App";
import { EmergencyTreatmentApi } from "../../../../api/EmergencyTreatmentApi";
import { CreateEmergencyTreatmentModal } from "../../EmergencyTreatment/CreateEmergencyTreatmentModal";
import { ICreateEmergencyTreatmentReport } from "../../../../models/IEmergencyTreatment";
import { IEmergencyTreatmentModel } from "../../../../models/IPatient";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";
import { Link } from "react-router-dom";
import { setMessage } from "../../../../helpers/MessageHelper";

interface IEmergencyTreatmentTab {
    emergencyTreatmentReports: IEmergencyTreatmentModel;
    patientId: number;
    reloadData: () => void;
}

interface ILoading {
    isLoading: boolean;
    emergencyTreatmentReportId: number;
    
}

export const EmergencyTreatmentTab: React.FunctionComponent<IEmergencyTreatmentTab> = ({ emergencyTreatmentReports, patientId, reloadData }) => {
    const auth = useAuth();
    const api = new EmergencyTreatmentApi(auth);
    const history = useHistory();
    const [isApiCallPending, setIsApiCallPending] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isLoading, setIsLoading] = React.useState<ILoading>();
    let match = useRouteMatch();

    const openDatePickerModal = () => {
        document.getElementById("open-modal")?.click();
    }

    const createEmergencyTreatment = (data: ICreateEmergencyTreatmentReport) => {
        setIsApiCallPending(true);
        api.createEmergencyTreatmentReport({ patientId: patientId, dateOfTreatment: data.dateOfTreatment, carePerformerId: data.carePerformerId }, (createdId: number) => {
            document.getElementById("close-modal")?.click();
            setIsApiCallPending(false);
            history.push(`${match.url}/${EMERGENCY_TREATMENT}/${createdId}`)
        }, (message) => {
            const newMessage = setMessage(message, errorMessage);
            setErrorMessage(newMessage);
            setIsApiCallPending(false);
        });
    }

    const closeDatePickerModal = () => {
        document.getElementById("close-modal")?.click();
        setErrorMessage("");
    }

    const renderTableLink = (linkText: string, emergencyTreatmentReportId: number) => {
        return <Link to={`${match.url}/${EMERGENCY_TREATMENT}/${emergencyTreatmentReportId}`}>{linkText}</Link>
    }

    const removeEmergencyTretmentReport = (emergencyTreatmentReportId: number) => {
        const confirmed = window.confirm("Är du säker på att du vill ta bort akuträkningen?");
        if (confirmed) {
            setIsLoading({ isLoading: true, emergencyTreatmentReportId: emergencyTreatmentReportId });
            api.deleteEmergencyTreatmentReport(emergencyTreatmentReportId, reloadData, undefined, () => setIsLoading({ isLoading: false, emergencyTreatmentReportId: emergencyTreatmentReportId }));
        }
    }

    return (
        <section>
            {
                emergencyTreatmentReports.canCreateEmergencyTreatment ?
                    <div className="panel text-right">
                        <CustomButton buttonText="Skapa akuträkning" buttonType={ButtonType.create} onClick={() => openDatePickerModal()} />
                    </div>
                    : null
            }
            <input type="hidden" data-toggle="modal" id="open-modal" data-target="#create-emergency-treatment-modal" />
            <CreateEmergencyTreatmentModal onSubmit={createEmergencyTreatment} errorMessage={errorMessage} closeForm={() => closeDatePickerModal()} isLoading={isApiCallPending} />

            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Akuträkningsnummer</th>
                        <th>Skapad</th>
                        <th>Betalningsansvarig</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        emergencyTreatmentReports.emergencyTreatments.length > 0
                            ? emergencyTreatmentReports.emergencyTreatments.map((emergencyTreatmentReport, key) => {
                                return (
                                    <tr key={key} className="clickable-row">
                                        <td className="table-data-link">{renderTableLink(emergencyTreatmentReport.emergencyTreatmentReportNumber?.toString(), emergencyTreatmentReport.id)}</td>
                                        <td className="table-data-link">{renderTableLink(dateTimeToDateString(emergencyTreatmentReport.dateCreated), emergencyTreatmentReport.id)}</td>
                                        <td className="table-data-link">{renderTableLink(emergencyTreatmentReport.responsibleCareProvider, emergencyTreatmentReport.id)}</td>
                                        <td className="delete-btn">
                                            {
                                                emergencyTreatmentReport.canBeDeleted ?
                                                    <CustomButton
                                                        buttonType={ButtonType.delete}
                                                        buttonText=""
                                                        onClick={() => removeEmergencyTretmentReport(emergencyTreatmentReport.id ?? 0)}
                                                        isLoading={isLoading?.emergencyTreatmentReportId === emergencyTreatmentReport.id && isLoading?.isLoading} />
                                                    : null
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan={4}>Det finns inga akuträkningar</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    );
}